import type * as React from "react";
import { cn } from "../lib/utils";

type LogoProps = React.SVGProps<SVGSVGElement>;

export function Logo({ className, ...props }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="83"
      height="28"
      viewBox="0 0 715 117"
      fill="currentColor"
      className={cn("text-gray-12 dark:text-white", className)}
      {...props}
    >
      <g>
        <g transform="matrix(0.952381,0,0,0.952381,-451.529207,-152.880203)">
          <g transform="matrix(174.535571,0,0,174.535571,473.407525,282.699112)">
            <path d="M0.228,-0L0.228,-0.568L0.004,-0.568L0.004,-0.7L0.614,-0.7L0.614,-0.568L0.39,-0.568L0.39,-0L0.228,-0Z" />
          </g>

          <g transform="matrix(174.535571,0,0,174.535571,581.234867,282.699112)">
            <path d="M0.083,-0L0.083,-0.7L0.612,-0.7L0.612,-0.57L0.244,-0.57L0.244,-0.13L0.625,-0.13L0.625,-0L0.083,-0ZM0.232,-0.292L0.232,-0.418L0.569,-0.418L0.569,-0.292L0.232,-0.292Z" />
          </g>

          <g transform="matrix(174.535571,0,0,174.535571,698.38136,282.699112)">
            <path d="M0.083,-0L0.083,-0.7L0.382,-0.7C0.479,-0.7 0.555,-0.677 0.609,-0.632C0.663,-0.587 0.69,-0.525 0.69,-0.446C0.69,-0.394 0.678,-0.349 0.653,-0.312C0.629,-0.274 0.594,-0.245 0.548,-0.225C0.503,-0.205 0.448,-0.195 0.386,-0.195L0.173,-0.195L0.245,-0.266L0.245,-0L0.083,-0ZM0.528,-0L0.353,-0.254L0.526,-0.254L0.703,-0L0.528,-0ZM0.245,-0.248L0.173,-0.324L0.377,-0.324C0.427,-0.324 0.464,-0.335 0.489,-0.357C0.514,-0.378 0.526,-0.408 0.526,-0.446C0.526,-0.485 0.514,-0.515 0.489,-0.536C0.464,-0.557 0.427,-0.568 0.377,-0.568L0.173,-0.568L0.245,-0.645L0.245,-0.248Z" />
          </g>
        </g>

        <g transform="matrix(1,0,0,1,355.852818,0)">
          <path d="M0,116.357L100,0L159,0L216.357,50L158.179,50L129.089,25L50,116.357L0,116.357Z" />
          <path d="M164,116.357L214,116.357L314,0L264,0L164,116.357Z" />

          <g transform="matrix(1,0,0,1,-282.764573,-176.342065)">
            <g transform="matrix(0.894616,0,0,0.894616,88.96039,129.041181)">
              <circle cx="592.773" cy="145.85" r="25.15" />
            </g>

            <g transform="matrix(0.894616,0,0,0.894616,88.96039,79.041181)">
              <circle cx="592.773" cy="145.85" r="25.15" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
